import React, { useState } from 'react'
import { css } from 'emotion'
import Carousel, { Modal, ModalGateway } from 'react-images'
import {
  CFIcon,
  CFImage,
  CFLink,
  CFSelect,
  CFView,
  DefaultScreen,
  LocationSelect,
  MobileScreen,
} from 'components'
import { headerBg, logo, mobileLogo, logoTitle, viewMenu } from 'images'
import { dispatch } from 'store'
import ViewMenuButton from './ViewMenuButton'

const orderingUrl =
  process.env.REACT_APP_ENVIRONMENT === 'dev'
    ? 'https://demo.codefusion.tech/restaurants/ebisu/locations/ebisuLocation1'
    : 'https://order.codefusion.tech/restaurants/8GFwb8UTNOQ2rbtqc9kk/locations/Y7GXtSFgqD6z5v9Jpd8q'

const images = []

export default () => {
  const [showModal, setShowModal] = useState(false)

  return (
    <>
      <MobileScreen>
        <CFView column center w="100%" bg="rgba(0, 0, 0, 0.8)"></CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView w="100%" zIndex={98} bg="#ECE4DA" pv="5px">
          <CFView row justifyBetween alignCenter w="100%" maxWidth="1400px">
            <CFImage
              ml="50px"
              w="390px"
              src={logo}
              alt="Hana Sushi Chilliwack Logo"
              zIndex={98}
            />
            <ViewMenuButton />
          </CFView>
        </CFView>
      </DefaultScreen>
      <ModalGateway>
        {showModal ? (
          <Modal onClose={() => setShowModal(false)}>
            <Carousel views={images} />
          </Modal>
        ) : null}
      </ModalGateway>
    </>
  )
}

const styles = {
  hyperlink: css({
    color: '#EBC14C',
    visitedColor: '#EBC14C',
    textDecoration: 'none',
  }),
}
